module.exports = __webpack_public_path__ + "media/images/user/favicons/android-chrome-384x384-2b5936179c57bbeb3dd36c036aa335e5.png";